import { useTheme } from '@emotion/react';
import { useAtom } from 'jotai';
import React, { useCallback } from 'react';

import { Flex, Pagination } from '~/components/blocks';
import { filePageInfoState } from '~/state/partials/patient_karte/atoms';

export const FilePagination = () => {
  const theme = useTheme();

  const [pageInfo, setPageInfo] = useAtom(filePageInfoState);
  const handleChangePage = useCallback(
    (page: number) => setPageInfo((_state) => ({ ..._state, page })),
    [setPageInfo],
  );

  return (
    <Flex justifyContent="center" marginTop={theme.space.l}>
      <Pagination
        currentPage={pageInfo.page}
        totalPage={pageInfo.totalPage}
        onChange={handleChangePage}
      />
    </Flex>
  );
};
